import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const UserDashboard = () => {
  return (
    <div className='page__wrapper'>
        <Navbar />
        <div className='dashboard__container'>
            <div className='dashboard'>
            </div>
        </div>
    </div>
  )
}

export default UserDashboard
